/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import clsx from 'clsx';
import { ReactNode } from 'react';

import headerStyles from '../chat/components/InnerMessage/InnerMessageHeader.module.scss';
import styles from './DynamedTabContentPage.module.scss';

type SectionNavigationProps = {
  currentSectionName: string;
  headerExtra?: ReactNode;
  label: string;
  nextSectionName?: string;
  onNextSection: () => void;
  onPreviousSection: () => void;
  position: 'top' | 'bottom';
  previousSectionName?: string;
  sectionCount: number;
  selectedSectionIndex: number;
  isHeader?: boolean;
};

export function SectionNavigation({
  currentSectionName,
  headerExtra,
  label,
  nextSectionName,
  onNextSection,
  onPreviousSection,
  position,
  previousSectionName,
  isHeader,
  sectionCount,
  selectedSectionIndex,
}: SectionNavigationProps) {
  return (
    <nav
      aria-label={`${label} section navigation ${position}`}
      className={clsx(styles.sectionNavigation, position === 'bottom' && styles.sectionNavigationBottom)}
    >
      <button
        className={clsx(styles.sectionNavLink, !previousSectionName && styles.sectionNavLinkDisabled)}
        disabled={!previousSectionName}
        onClick={onPreviousSection}
        type="button"
      >
        Previous section{previousSectionName ? `: ${previousSectionName}` : ''}
      </button>
      <span className={styles.sectionProgress}>
        {isHeader && (
          <span className={styles.sectionProgressTitle}>
            {currentSectionName}
            {headerExtra && (
              <span className={clsx(headerStyles.pageChrome, styles.sectionProgressExtra)}>{headerExtra}</span>
            )}
          </span>
        )}
      </span>
      <button
        className={clsx(styles.sectionNavLink, !nextSectionName && styles.sectionNavLinkDisabled)}
        disabled={!nextSectionName}
        onClick={onNextSection}
        type="button"
      >
        Next section{nextSectionName ? `: ${nextSectionName}` : ''}
      </button>
    </nav>
  );
}
